<template>
  <b-col cols="12" class="add-origin-destination">
    <button
      type="button"
      role="button"
      :class="`add-origin-destination__button ${disabled ? 'add-origin-destination__button--disabled' : ''}`"
      :disabled="disabled"
      @click="() => $emit('add:origin-destination')"
    >
      <span>Aggiungi un altro volo <strong>+</strong></span>
    </button>
  </b-col>
</template>

<script>
export default {
  name: "add-origin-destination",
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
  .add-origin-destination {
    display: flex;
    justify-content: flex-end;
    padding-top: $grid-gutter-width / 3;
    padding-right: 0;
    margin-bottom: $grid-gutter-width / 2;
    padding-bottom: $grid-gutter-width / 2;
    border-color: $gray-200;
    border-style: solid;

    @include media-breakpoint-up(lg) {
      border-width: 0 0 1px 0;
    }

    @include media-breakpoint-down(lg) {
      justify-content: center;
      padding-bottom: 0;
      border-width: 1px 0 0;
    }

    &__button {
      color: var(--info);
      border: none;
      background-color: transparent;
      font-size: $font-size-base;
      font-weight: $vb-font-weight-semibold;
      display: flex;
      align-items: center;
      gap: 5px;

      @include media-breakpoint-up(lg) {
        font-size: $font-size-md;
        align-items: normal;
      }

      span {
        display: flex;
        align-items: center;
        gap: 5px;

        strong {
          font-weight: $vb-font-weight-bold;
          font-size: $font-size-base
        }
      }

      &--disabled {
        color: #ADB5BD;
        cursor: default;
      }
    }
  }
</style>
